import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import FolderId from 'owa-service/lib/contract/FolderId';
import getCalendarFolderConfigurationOperation from 'owa-service/lib/operation/getCalendarFolderConfigurationOperation';
import GetCalendarFolderConfigurationResponse from 'owa-service/lib/contract/GetCalendarFolderConfigurationResponse';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { Calendar } from 'mini-event-to-calendar-association/lib/schema/Calendar';

/**
 * Makes the GetCalendarFolderConfiguration call to the server to get the CalendarFolder object
 * @param {FolderId} folderId id of the calendar's configuration that needs to be fetched
 * @param {string} email smtp addres of request mailbox
 * @returns promise of calendar folder object
 */
export async function getCalendarFolderConfigurationService(
    calendar: Calendar,
    folderId: FolderId,
    email: string
): Promise<GetCalendarFolderConfigurationResponse> {
    const headers = new Headers();
    if (email) {
        headers.set('X-OWA-ExplicitLogonUser', email);
        headers.set('X-AnchorMailbox', email);
    }

    const options: RequestOptions = { headers };

    // For a GS or group calendar we dont have the folder id there we use the DistinguisedFolderIdName
    let calculatedFolderId;
    if (calendar && (calendar.isGeneralScheduleCalendar || calendar.isGroupMailboxCalendar)) {
        calculatedFolderId = distinguishedFolderId({
            Id: 'calendar',
            Mailbox: {
                EmailAddress: email,
            },
        });
    } else if (calendar.CalendarFolderType === CalendarFolderTypeEnum.PublicCalendarFolder) {
        calculatedFolderId = calendar.SharedFolderId;
    } else {
        calculatedFolderId = folderId;
    }

    return getCalendarFolderConfigurationOperation(
        {
            request: {
                FolderId: calculatedFolderId,
            },
        },
        options
    );
}
